import { render, staticRenderFns } from "./CollectPay.vue?vue&type=template&id=7a906cb7&scoped=true&"
import script from "./CollectPay.vue?vue&type=script&lang=js&"
export * from "./CollectPay.vue?vue&type=script&lang=js&"
import style0 from "./CollectPay.vue?vue&type=style&index=0&id=7a906cb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a906cb7",
  null
  
)

export default component.exports